import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemDividedBox from '../FormItemDividedBox';

export default class FormItemDividedBoxControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemDividedBoxControl";
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
		this.component = <FormItemDividedBox key={this.xml.id} xml={this.xml} 
                parentLayout={layout} forLookup={forLookup} moduleInstanceId={this.module.instanceUUId}  
                groupAlias={this.groupAlias} customStyle={this.getStyle()}
                formId={this.formId} menuItemId={this.menuItemId}
                contextMenuData={this.contextMenuData} {...commonProps}/>;
		return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemDividedBoxControl.js